class Recording < ApplicationRecord
  belongs_to :heat
  belongs_to :judge
end
